import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import ColorSwatch from './colorSwatch';
import { isFullPrice, isColourVariantFullPrice } from '../productDetailsUtils';

class ColorSwatches extends Component {
  constructor() {
    super();

    this.state = {
      initialChecking: false,
      displaySwatchName: null,
    };

    this.updateDisplaySwatchName = this.updateDisplaySwatchName.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { colorSwatches, actualColorSwatch } = nextProps;
    if (!isEmpty(colorSwatches) && !isEmpty(actualColorSwatch) && !prevState.initialChecking) {
      return {
        initialChecking: true,
        displaySwatchName: actualColorSwatch.displayName,
      };
    }

    return null;
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  updateDisplaySwatchName(displaySwatchName) {
    const { actualColorSwatch } = this.props;
    const newDisplayName = displaySwatchName || actualColorSwatch.displayName;
    this.setState({ displaySwatchName: newDisplayName });
  }

  render() {
    const { colorSwatches, actualColorSwatch, fetchProductDetails, loadedProduct } = this.props;
    const { displaySwatchName } = this.state;

    if (!colorSwatches || !actualColorSwatch) {
      return null;
    }

    const currentProductSaleOrNoneSale = isFullPrice(loadedProduct);
    const filteredColorSwatches = colorSwatches
      .filter(colorSwatch => currentProductSaleOrNoneSale === isColourVariantFullPrice(colorSwatch))
      .filter(colorSwatch => colorSwatch.hasStock || colorSwatch.id === actualColorSwatch.id);

    return (
      <div className="pdp__color-swatches">
        <p className="pdp__color-swatches-label">
          <FormattedMessage id="products.pdp.colorswatches.color" description="Colour" />
          <span className="pdp__color-swatches-name ellipsis"> - {displaySwatchName} </span>
        </p>

        <div className="pdp__color-swatches-list" id="swatches-list">
          <ul className="pdp__color-swatches-visible-list">
            {filteredColorSwatches.map(colorSwatch => (
              <ColorSwatch
                key={colorSwatch.id}
                id={colorSwatch.id}
                name={colorSwatch.displayName}
                active={colorSwatch.id === actualColorSwatch.id}
                seoUrl={colorSwatch.seoUrl}
                mediaURL={colorSwatch.mediaURL}
                onChange={this.updateDisplaySwatchName}
                onClick={fetchProductDetails}
              />
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

ColorSwatches.propTypes = {
  colorSwatches: PropTypes.arrayOf(PropTypes.any).isRequired,
  actualColorSwatch: PropTypes.object.isRequired,
};

export default ColorSwatches;
